$(document).ready(function () {
  $(".custom_atc_button").click(function () {
    var currentId = $(this).attr("data-id");
    var mode = $(this).attr("data");
    var sellingPlanId = $(this).attr("data-sub-id");
    var quantityCur = $(this).closest(".formCont").find(".gf_pq_qty").val();

    console.log(mode, "MODE");

    if (mode == "sub") {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        success: function () {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: currentId,
              quantity: quantityCur,
              selling_plan: sellingPlanId,
            },
            success: function () {
              window.location.href = "/checkout";
            },
          });
        },
      });
    } else {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        success: function () {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: currentId,
              quantity: quantityCur,
            },
            success: function () {
              window.location.href = "/checkout";
            },
          });
        },
      });
    }
  });

  $(".custom_atc_button_cart").click(function () {
    var currentId = $(this).attr("data-id");
    var mode = $(this).attr("data");
    var sellingPlanId = $(this).attr("data-sub-id");
    var quantityCur = $(this).closest(".formCont").find(".gf_pq_qty").val();

    console.log(mode, "MODE");

    if (mode == "sub") {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        success: function () {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: currentId,
              quantity: quantityCur,
              selling_plan: sellingPlanId,
            },
            success: function () { },
          });
        },
      });
    } else {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        success: function () {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: currentId,
              quantity: quantityCur,
            },
            success: function () { },
          });
        },
      });
    }
  });

  $(".product_tab-block").click(function () {
    $(this).toggleClass("active");
    $(this).find(".product_tab-content").slideToggle();
  });

  $(".main_product-image-carousel").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: ".main_product-image-carousel_thumbs",
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0629/0898/9620/files/Button_-_Previous_slide.png?v=1780482759'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0629/0898/9620/files/Button_-_Next_slide.png?v=1780482759'/></button>",
  });

  $(".main_product-image-carousel_thumbs").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    focusOnSelect: true,
    asNavFor: ".main_product-image-carousel",
  });

  $('.ka_backed-videos-grid').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '10%',
    arrows: false,
    dots: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '70px',
        }
      },
    ]
  });


  $('.mp_main-atc-btn').click(function(){


      var items = [];
      var currentId = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-id");
      var mode = $(".product-selector_outer.active_block").attr("data");
      var currentSellingPlan = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-selling-plan");

      if (mode == "sub") {
        items.push({ id: currentId, quantity: 1, selling_plan: currentSellingPlan });
      } else {
        items.push({ id: currentId, quantity: 1 });
      }
      console.log("currentId" + currentId);

      // if (items.length > 0) {
      //   fetch('/cart/add.js', {
      //     method: 'POST',
      //     headers: { 'Content-Type': 'application/json' },
      //     body: JSON.stringify({ items: items })
      //   })
      //   .then(res => res.json())
      //   .then(function() {
      //     // OCU should intercept this and open automatically
      //   });
      // }

     fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(res => res.json())
      .then(function() {
        dispatchEvent(new Event('ocu:cart:open:updated'))
      });
  });

//   // Open cart drawer after updating a cart state
// dispatchEvent(new Event('ocu:cart:open:updated'))

// // Update cart without opening
// dispatchEvent(new Event('ocu:cart:update'))

// // Update cart without opening with custom state
// dispatchEvent(new Event('ocu:cart:update', {
//     detail: { cart: customCartState }
// }))

// // Open cart drawer
// dispatchEvent(new Event('ocu:cart:open'))


  $('.ka_superfood-ingr-cell').click(function(){
    $(this).toggleClass('active');
  });


  $('.ka_superfood-faq-cell').click(function(){
    $(this).toggleClass('active');
    $(this).find('.ka_superfood-faq-content').slideToggle();
  });


  $('.ka_superfood-feel-carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '15%',
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0629/0898/9620/files/Screenshot_2026-06-03_at_21.58.10.png?v=1780513102'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0629/0898/9620/files/Screenshot_2026-06-03_at_21.58.10.png?v=1780513102'/></button>",
    dots: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      },
    ]
  });

  $('.ka_building-blocks.Mobile_only').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    allowTouchMove: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0629/0898/9620/files/Button_-_Next.png?v=1782542969'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0629/0898/9620/files/Button_-_Next.png?v=1782542969'/></button>",
    responsive: [
      {
        breakpoint: 677,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $('.ka_main-btn').click(function(evt){
    evt.preventDefault();
    $('html, body').animate({
        scrollTop: $(".mp_info-block_callogen").offset().top
    }, 500);
  });
});
